<template>
  <div class="l-row">
    <loader :loading="loading"/>
    <form-group v-for="(attribute, index) in attributes" :key="attribute" :label="attribute.name" :columns="4" :required="attribute.tags && attribute.tags.required || attribute.attributeUsedAsVariation" v-if="attribute.id !== 'SELLER_SKU' && attribute.id !== 'SIZE_GRID_ROW_ID'" :error="getError(attribute.id, errorIndex)">
      <select class="form-select" v-model="product.attributes[attribute.id]" v-if="isSelectWithId(attribute) && Object.keys(custom).indexOf(attribute.id) === -1" @change="onChangeAttribute(attribute.id, product.attributes[attribute.id])">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id">{{ attributeValue.name }}</option>
      </select>

      <div v-else-if="isSelectWithId(attribute) && Object.keys(custom).indexOf(attribute.id) !== -1">
        <select class="form-select" v-model="product.attributes[attribute.id]" v-if="!custom[attribute.id]" @change="onChangeAttribute(attribute.id, product.attributes[attribute.id])">
          <option :value=null>{{ $t('choose.label') }}</option>

          <optgroup :label="$t(`custom.${attribute.id.toLowerCase()}.label`)">
            <option value="custom" v-if="Object.keys(custom).indexOf(attribute.id) !== -1">Adicionar personalizada</option>
            <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id" v-if="attributeValue.custom">{{ attributeValue.name }}</option>
          </optgroup>

          <optgroup :label="$t(`default.${attribute.id.toLowerCase()}.label`)">
            <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id" v-if="!attributeValue.custom">{{ attributeValue.name }}</option>
          </optgroup>
        </select>

        <span v-else>
          <editable value="" :isEditable="true" :onConfirm="(a, b) => onConfirmAttribute(a, b, attribute.id)" :onCancel="() => onCancelAttribute(attribute.id)"/>
        </span>
      </div>

      <input class="form-input" @change="onChangeAttribute(attribute.id, product.attributes[attribute.id])" type="text" v-model="product.attributes[attribute.id]" v-else-if="!attribute.default_unit && attribute.id !== 'SIZE_GRID_ID'" :disabled="attribute.id === 'EAN' && typeCheckout">

      <select class="form-select" v-else-if="attribute.id === 'SIZE_GRID_ID'">
        <option>Selecione a Guia de Medidas</option>
      </select>

      <div class="form-flex" v-else>
        <input class="form-input" type="text" v-model="product.attributes[attribute.id]">
        <span class="form-addon">
          <select v-model="attribute.default_unit" class="form-select form-select--sm">
            <option :value="unit.id" v-for="unit in attribute.allowed_units">{{ unit.name }}</option>
          </select>
        </span>
      </div>
    </form-group>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Editable from '@/components/template/Editable/Base'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      custom: {
        COLOR: false,
        SIZE: false,
        BRAND: false,
        MODEL: false,
        TEAM: false
      },
      loading: false,
      variationSizes: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      attributes: {
        type: Array,
        required: true
      },
      typeCheckout: {
        type: Boolean,
        default: false
      },
      announcementConfigurations: {
        type: Array,
        required: false
      }
    },
    mounted () {
      for (let i in Object.keys(this.custom)) {
        const attributeId = Object.keys(this.custom)[i]
        const attributeCategory = this.attributes.find(attribute => attribute.id === attributeId)

        if (attributeCategory !== undefined && attributeCategory.values !== undefined) {
          if (this.product.attributes !== undefined && this.product.attributes[attributeId] !== undefined) {
            const existingValue = this.product.attributes[attributeId]

            const valueExists = attributeCategory.values.some(value =>
              value.id === existingValue || value.name === existingValue
            )

            if (!valueExists) {
              attributeCategory.values.push({
                id: existingValue,
                name: existingValue,
                custom: true
              })
            }
          }
        }
      }

      if (this.product.attributes['GENDER']) {
        const attributeGender = this.attributes.find(attribute => attribute.id === 'GENDER')
        const optionDefault = attributeGender.values.find(value => value.id === this.product.attributes['GENDER'])
        this.product.attributes['GENDER'] = optionDefault.id
      }

      this.getSizeGrids()
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      isSelectWithId (attribute) {
        return !!attribute.values
      },
      getAttributeValueName (id) {
        if (this.product.attributes[id]) {
          var attribute = this.attributes.find(attribute => attribute.id === id)
          if (attribute.values !== undefined) {
            try {
              var optionDefault = attribute.values.find(value => value.id === this.product.attributes[id])
              return optionDefault.name
            } catch (exception) {
              //
            }
          }
          return this.product.attributes[id]
        }
      },
      async onChangeAttribute (attributeId, value) {
        if (attributeId === 'BRAND' || attributeId === 'GENDER') {
          if (this.product.attributes['BRAND'] !== undefined && this.product.attributes['GENDER'] !== undefined) {
            const attributeGender = this.attributes.find(attribute => attribute.id === 'GENDER')
            const gender = attributeGender.values.find(value => value.id === this.product.attributes['GENDER'])

            const attributeBrand = this.attributes.find(attribute => attribute.id === 'BRAND')

            let brand = {}

            if (attributeBrand.values !== undefined) {
              brand = attributeBrand.values.find(value => value.id === this.product.attributes['BRAND'])
            } else {
              brand.name = this.product.attributes['BRAND']
            }

            if ((brand !== undefined || value !== undefined) && gender !== undefined) {
              let brandName = ''

              if (brand !== undefined) {
                if (brand.name === 'custom') {
                  brandName = value
                } else {
                  brandName = brand.name
                }
              } else {
                brandName = value
              }

              if (brandName !== 'custom') {
                this.getSizeGrids()
              }
            }
          }
        }

        if (Object.keys(this.custom).indexOf(attributeId) === -1 || value !== 'custom') {
          return false
        }

        this.custom[attributeId] = true
      },
      onConfirmAttribute (oldValue, newValue, attributeId) {
        if (attributeId === 'BRAND') {
          this.onChangeAttribute(attributeId, newValue)
        }

        this.attributes.find(attribute => attribute.id === attributeId).values.push({ id: newValue, name: newValue, custom: true })
        this.product.attributes[attributeId] = newValue

        this.custom[attributeId] = false
      },
      onCancelAttribute (attributeId) {
        this.product.attributes[attributeId] = null
        this.custom[attributeId] = false
      },
      async getSizeGrids () {
        var lastCategory = this.product.category

        if (lastCategory === undefined) {
          let categories = this.product.categories

          if (categories === undefined) {
            return false
          }

          lastCategory = categories[categories.length - 1]
        }

        var productGenderName = this.getAttributeValueName('GENDER')

        var productBrandName = this.getAttributeValueName('BRAND')

        if (lastCategory === undefined || productGenderName === undefined || productBrandName === undefined) {
          return false
        }

        this.clearErrors()

        this.loading = true

        let accountIdentifier = null

        if (this.product.account !== undefined) {
          accountIdentifier = this.product.account.identifier
        }

        if (this.announcementConfigurations !== undefined) {
          if (this.announcementConfigurations[0] !== undefined) {
            accountIdentifier = this.announcementConfigurations[0].account.identifier
          }
        }

        const data = {
          category: lastCategory,
          brand: productBrandName,
          gender: productGenderName
        }

        try {
          var customSizeGridList = await api.mercadoLivre.getCustomSizeGridList(data, accountIdentifier)

          for (let i in Object.keys(this.attributes)) {
            if (this.attributes[i].id === 'SIZE_GRID_ID') {
              this.attributes[i].tags = { required: true }
              this.attributes[i].values = customSizeGridList
            }

            if (this.attributes[i].id === 'CUSTOM_SIZE_GRID_TABLE_ID') {
              this.attributes[i].values = customSizeGridList
            }
          }
        } catch (err) {
          //
        }

        this.loading = false
        return
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      errorIndex () {
        return this.product.sku ? this.product.sku : this.product.productId
      }
    },
    watch: {
      'product.attributes' (value) {
        this.product.attributes = value
      }
    },
    components: {
      Panel,
      FormGroup,
      Editable,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .form-input,
  .form-select:not(.form-select--sm)
    height: 42px
</style>



// WEBPACK FOOTER //
// Attributes.vue?b5d10cbc